<template>
  <div>
    <v-tabs v-model="tab">
      <v-tab key="1">{{ Translator('admin.notice_collection.facets.area1') }}</v-tab>
      <v-tab key="2">{{ Translator('admin.notice_collection.facets.area2') }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item key="1">
        <ZoneList zone-notice="1"></ZoneList>
      </v-tab-item>
      <v-tab-item key="2">
        <ZoneList zone-notice="2"></ZoneList>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>

import ZoneList from './ZoneList'

export default {
  name: 'AdminConfigNoticeRendering',
  components: {
    ZoneList
  },
  data () {
    return {
      tab: null
    }
  },
  methods: {
    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  }
}
</script>

